/**
 * LE D20, MONTRÉ.
 *
 * « Les jets de dés sont montrés — le d20, le modificateur, le seuil — parce qu'un permadeath sur
 * un jet caché est insupportable, et parce que le moteur est déterministe et peut tout justifier »
 * (design §3). Ce composant est donc l'un des rares à ne pas être décoratif : il est une PREUVE.
 *
 * Le résultat est écrit dans le dé, le calcul à côté, et l'issue est dite en toutes lettres par
 * l'appelant — la couleur du contour ne porte jamais l'information seule.
 */
interface Props {
  jet: number;
  total?: number;
  dd?: number;
  reussi?: boolean;
  critique?: boolean;
  echecCritique?: boolean;
  taille?: number;
}

export function De({ jet, total, dd, reussi, critique, echecCritique, taille = 34 }: Props) {
  const classes = [
    "de",
    "de--jete",
    critique ? "de--critique" : "",
    echecCritique ? "de--rate" : "",
    !critique && !echecCritique && reussi === true ? "de--reussi" : "",
    !critique && !echecCritique && reussi === false ? "de--rate" : ""
  ]
    .filter(Boolean)
    .join(" ");

  const detail = total !== undefined && dd !== undefined ? `total ${total} contre ${dd}` : undefined;

  return (
    <span className="rang rang--serre" style={{ gap: "var(--e2)" }}>
      <svg className={classes} width={taille} height={taille} viewBox="0 0 40 40" role="img" aria-label={`d20 : ${jet}${detail ? `, ${detail}` : ""}`}>
        {/* Un icosaèdre vu de face : le triangle du dessus, la ceinture, la pointe. */}
        <polygon className="de__corps" points="20,2 37,12 37,28 20,38 3,28 3,12" />
        <path className="de__facettes" d="M20 2L9 15h22zM9 15l-6-3M31 15l6-3M9 15l11 23M31 15L20 38M9 15h22" />
        <text className="de__nombre" x="20" y="21">
          {jet}
        </text>
      </svg>
      {detail ? (
        <span className="capitales" style={{ letterSpacing: "0.08em" }}>
          {detail}
        </span>
      ) : null}
    </span>
  );
}
